import React from 'react';
import AuthInitializer from '../components/AuthInitializer.jsx';

/**
 * HOC that wraps UrlSpecHandler to also trigger auth initialization
 */
const UrlSpecHandlerWrapper = (Original, system) => {
  const Wrapper = (props) => {
    const { pagoAuth2Actions } = system;

    return (
      <>
        <AuthInitializer pagoAuth2Actions={pagoAuth2Actions} />
        <Original {...props} />
      </>
    );
  };

  return Wrapper;
};

export default UrlSpecHandlerWrapper;
